export const clientId = '4'
export const clientSecret = 'XQQe7d7m6GhDu6ZGrf217DvxAoCtamwZqUmcytrQ'



// WEBPACK FOOTER //
// ./src/env.js